import { isServer } from '@@/services/env';

/**
 * Image path dynamic asset helper.
 * Uses PUBLIC_URL to resolve the correct path to all files served in the
 * public/ directory.
 *
 * @param path The relative path to the file.
 */
export function assetPath(path: string) {
  return `${process.env.PUBLIC_URL}/${path.replace(/^\//, '')}`;
}

/**
 * URLs that come from env vars sometimes need to be tweaked before use
 * when working in different environments, such as Jest/Cypress/etc.
 */
export function prepUrlForEnvironment({
  url: urlEnvVar,
  shouldUseCurrentHost = (hostname) =>
    hostname === 'localhost' || hostname.includes('sure.town'),
}: {
  url?: string;
  shouldUseCurrentHost?: (hostname: string) => boolean;
}) {
  const defaultUrl = '/';

  if (isServer) {
    return defaultUrl;
  }

  const {
    location: { hostname },
    Cypress,
  } = window;

  return shouldUseCurrentHost(hostname) || Cypress
    ? defaultUrl
    : urlEnvVar ?? defaultUrl;
}
